export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./new_comercial.vue?vue&type=template&id=5cff17d8&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/Details/new_comercial.vue?vue&type=template&id=5cff17d8&
// module id = null
// module chunks = 